window.Drupal.behaviors.normaStickyMenu = {
    attach: function (context) {
        once('sticky-menu', '.sticky-menu', context).forEach((stickyMenu) => {
            const headerContainer = context.querySelector('#header-container');
            stickyMenu.querySelectorAll('.sticky-menu__link').forEach((link) => {
                link.addEventListener('click', (e) => {
                    if (headerContainer) {
                        headerContainer.dispatchEvent(new Event('header-container:pause'));
                        setTimeout(() => {
                            headerContainer.dispatchEvent(new Event('header-container:resume'));
                        }, 1000);
                    }
                });
            });
        });
    },
};
